import { render } from "./SearchIcon-dark.vue?vue&type=template&id=4ae6e4ff"
const script = {}

import exportComponent from "/home/runcloud1user/webapps/brightflame/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__